import { createSelector } from 'reselect';
import { getWorkOrderManagement } from './getWorkOrderManagement';

/**
 * `{ totalParts }` derived from the selected card context, shared with both the
 * labor-ticket MFE and the activities run-details MFE via `partsContext.apmParts`.
 * Returns null when no card context is stored or when orderQuantity is absent.
 *
 * @returns {{ totalParts: number }|null}
 */
export const getApmCardPartsContext = createSelector(
  [getWorkOrderManagement],
  (workOrderManagement) => {
    const ctx = workOrderManagement?.apmCardContext;
    const uncoveredParts = ctx?.programEvent?.orderQuantity?.uncoveredParts;
    if (!uncoveredParts) {
      return null;
    }

    return { totalParts: uncoveredParts };
  }
);
